import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'


const axiosGlobalInstance = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API
});

// Add a request interceptor
// Define Headers
axiosGlobalInstance.interceptors.request.use(function (config) {
    
    const accessToken = localStorage.getItem('accessToken')

    if (accessToken) {
        config['headers']['Authorization'] = `Bearer ${accessToken}`;
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});

Vue.use(VueAxios, axiosGlobalInstance)